// src/services/api/NotificationsApi.tsx
import { BaseAPI } from "./BaseApi";

export type NotificationType =
  | "new_follower"
  | "post_like"
  | "achievement_unlock"
  | "new_message"
  | "follow_request"
  | "follow_request_approved"
  | "comment"
  | "comment_reply"
  | "lfg_player_joined"
  | "lfg_player_left"
  | "lfg_group_full"
  | "lfg_expired"
  | "match_created"
  | "match_channel_ready"
  | "match_cancelled"
  | "channel_creation_failed"
  | "queue_match_found"
  | "queue_expired"
  | "lobby_cancelled";

export interface Notification {
  notificationId: string;
  recipientId: string;
  type: NotificationType;
  metadata: Record<string, string>;
  read: boolean;
  createdAt: string;
}

export interface NotificationListResponse {
  items: Notification[];
  cursor: string | null;
  hasMore: boolean;
}

export interface UnreadCountResponse {
  count: number;
}

export interface MarkAllReadResponse {
  count: number;
}

export class NotificationsAPI extends BaseAPI {
  constructor() {
    super("");
  }

  async list(cursor?: string) {
    const params = new URLSearchParams();
    if (cursor) params.append("cursor", cursor);

    const queryString = params.toString();
    return this.request<NotificationListResponse>(
      `/api/notifications${queryString ? `?${queryString}` : ""}`,
      {
        method: "GET",
        auth: true,
      }
    );
  }

  async getUnreadCount() {
    return this.request<UnreadCountResponse>("/api/notifications/unread-count", {
      method: "GET",
      auth: true,
    });
  }

  async markRead(notificationId: string) {
    return this.request<Notification>(
      `/api/notifications/${notificationId}/read`,
      {
        method: "PATCH",
        auth: true,
      }
    );
  }

  async markAllRead() {
    return this.request<MarkAllReadResponse>("/api/notifications/read-all", {
      method: "PATCH",
      auth: true,
    });
  }

  async deleteNotification(notificationId: string) {
    return this.request<{ message: string }>(
      `/api/notifications/${notificationId}`,
      {
        method: "DELETE",
        auth: true,
      }
    );
  }
}
